import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantService } from '../services/tenant.service';

/**
 * Prefixos de endpoint globais (não-tenant). Requisições para esses caminhos
 * NÃO devem receber o header X-Domain-App, pois não operam no contexto de tenant:
 * - `/api/admin`: Área Administrativa (admin-area.md).
 * - `/api/help`: Central de Ajuda — conteúdo global e leitura anônima (épica #197).
 *
 * `/api/company/integration/validate` NÃO está na lista (#928): ele serve ao callback OAuth
 * anônimo (#812) e à reconexão pelo detalhe. Na reconexão a api só completa o segredo gravado
 * (`password` vazio = manter, kram.hub.api#2983) se vier `X-Domain-App` com a empresa. O
 * callback não é afetado: o endpoint é `[IgnoreTenant]` e a completação não roda com
 * `state`/`code`. Sem empresa ativa o interceptor já não manda cabeçalho nenhum.
 *
 * ⚠️ O nome do array é só documentação: o casamento é `url.includes(prefix)` — SUBSTRING em
 * qualquer posição da URL absoluta (`ApiConfigService.url()` monta
 * `${environment.apiUrl}${path}`), não prefixo de fato.
 */
const NON_TENANT_PATH_PREFIXES = ['/api/admin', '/api/help'];

function isNonTenantRequest(url: string): boolean {
  return NON_TENANT_PATH_PREFIXES.some(prefix => url.includes(prefix));
}

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  // Requisições globais (admin/ajuda) nunca enviam header de tenant
  if (isNonTenantRequest(req.url)) {
    return next(req);
  }

  const tenantService = inject(TenantService);
  const tenantId = tenantService.activeTenantId();

  if (!tenantId) return next(req);

  return next(req.clone({
    setHeaders: { 'X-Domain-App': tenantId }
  }));
};
